<template>
    <input
        ref="input"
        v-model="input"
        @input="updateValue($event.target.value)"
    />
</template>

<script>
export default {
    props: {
        value: {
            type: String
        },
    },

    data() {
        return {
            input: '',
            countSpacebar: 0,
            lastIndexDot: 0,
            manualDot: [],
        }
    },

    mounted() {
        this.input = this.value
    },

    methods: {
        updateValue: function (value) {
            this.$emit('input', value)
        },

        handleOnKeyDown(event) {
            const keyEvent = event || window.event
            const charCode = keyEvent.which ? keyEvent.which : keyEvent.keyCode

            if (charCode === 32 && charCode !== 190) {
                this.countSpacebar++

                if (this.countSpacebar >= 2) {
                    setTimeout(() => {
                        this.lastIndexDot = this.input.lastIndexOf('.')
                        if (this.lastIndexDot > -1 && this.manualDot.indexOf(this.lastIndexDot) < 0) {
                            this.input = this.replaceAt(this.input, this.lastIndexDot, ' ')
                        }
                    }, 50)
                }
            } else {
                if (charCode === 190) {
                    setTimeout(() => {
                        this.manualDot.push(this.input.lastIndexOf('.'))
                    }, 50)
                } else {
                    let cursorPosition = this.getInputSelection().start - 1
                    let foundIndex = this.manualDot.indexOf(cursorPosition)

                    if (foundIndex < 0) {
                        foundIndex = this.manualDot.indexOf(cursorPosition + 1)
                    }
                    setTimeout(() => {
                        if (foundIndex > -1 && (this.input.match(/\./g) || []).length < this.manualDot.length) {
                            this.manualDot = this.manualDot.filter((item, index) => foundIndex !== index)
                        }
                    }, 50)

                    this.countSpacebar = 0
                    this.lastIndexDot = 0
                }
            }
        },

        replaceAt(str, index, replacement) {
            return str.substr(0, index) + replacement + str.substr(index + replacement.length)
        },

        getInputSelection() {
            let el = this.$refs.input
            let start = 0
            let end = 0
            let normalizedValue = null
            let range = null
            let textInputRange = null
            let len = null
            let endRange = null

            if (typeof el.selectionStart == "number" && typeof el.selectionEnd == "number") {
                start = el.selectionStart;
                end = el.selectionEnd;
            } else {
                range = document.selection.createRange();

                if (range && range.parentElement() == el) {
                    len = el.value.length;
                    normalizedValue = el.value.replace(/\r\n/g, "\n");

                    // Create a working TextRange that lives only in the input
                    textInputRange = el.createTextRange();
                    textInputRange.moveToBookmark(range.getBookmark());

                    // Check if the start and end of the selection are at the very end
                    // of the input, since moveStart/moveEnd doesn't return what we want
                    // in those cases
                    endRange = el.createTextRange();
                    endRange.collapse(false);

                    if (textInputRange.compareEndPoints("StartToEnd", endRange) > -1) {
                        start = end = len;
                    } else {
                        start = -textInputRange.moveStart("character", -len);
                        start += normalizedValue.slice(0, start).split("\n").length - 1;

                        if (textInputRange.compareEndPoints("EndToEnd", endRange) > -1) {
                            end = len;
                        } else {
                            end = -textInputRange.moveEnd("character", -len);
                            end += normalizedValue.slice(0, end).split("\n").length - 1;
                        }
                    }
                }
            }

            return {
                start: start,
                end: end
            }
        },
    }
}
</script>